const isWeb = true;
import { toPx } from '@max/leez-style-util';
/**
 * 将 HTTP 图片 URL 转换为 HTTPS
 * @param url 输入的 URL
 * @returns 如果是 HTTP 图片 URL 则返回转换后的 HTTPS URL，否则返回原 URL
 */
export function convertToHttps(url) {
    // 检查 URL 是否为空或不是字符串类型
    if (!url || typeof url !== 'string') {
        return url;
    }
    // 检查 URL 是否以 "http://" 开头
    if (url.indexOf('http://') !== 0) {
        return url;
    }
    // 提取域名后的路径
    const path = url.slice(7); // 7 是 "http://".length
    // 检查是否为图片 URL
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
    const isImage = imageExtensions.some(ext => path.toLowerCase().indexOf(ext) > -1);
    if (isImage) {
        return 'https://' + path;
    }
    return url;
}
/**
 * 为图片URL添加宽度裁切参数
 * @param url 图片URL
 * @param width 目标宽度（像素）
 * @returns 处理后的URL
 */
export function appendImageWidth(url, width) {
    // 基础校验
    if (!url || typeof url !== 'string') {
        return url;
    }
    if (!width || typeof width !== 'number' || width <= 0) {
        return url;
    }
    try {
        const widthParam = '@' + Math.floor(width) + 'w';
        let dotIndex = url.lastIndexOf('.');
        // 检查是否为图片URL
        if (dotIndex === -1) {
            return url;
        }
        const ext = url.slice(dotIndex).toLowerCase();
        if (ext !== '.jpg' && ext !== '.jpeg' && ext !== '.png' && ext !== '.gif' && ext !== '.bmp' && ext !== '.webp') {
            return url;
        }
        // 检查扩展名后是否已有宽度参数
        const extEndIndex = dotIndex + ext.length;
        const hasWidthParam = url.slice(extEndIndex).indexOf('@') === 0;
        if (hasWidthParam) {
            // 已有宽度参数，替换它
            const wIndex = url.indexOf('w', extEndIndex);
            if (wIndex === -1)
                return url;
            const beforeParam = url.slice(0, extEndIndex);
            const afterParam = url.slice(wIndex + 1);
            return beforeParam + widthParam + afterParam;
        }
        // 在扩展名后添加宽度参数
        return url.slice(0, extEndIndex) + widthParam + url.slice(extEndIndex);
    }
    catch (error) {
        console.error('Error processing image URL:', error);
        return url;
    }
}
export function getRealImageSource(feImgSource, appendWidth = 750) {
    const { uri, width, height } = feImgSource;
    if (isWeb) {
        return {
            uri: appendImageWidth(convertToHttps(uri), appendWidth),
            width: `${width}rpx`,
            height: `${height}rpx`
        };
    }
    return {
        uri: appendImageWidth(convertToHttps(uri), appendWidth),
        width: toPx(width / 2),
        height: toPx(height / 2)
    };
}
